export const PagingSettings = {
  pageLimit: 10,
  pageRange: 5
};



// WEBPACK FOOTER //
// ./src/config/paging.js